import get from 'lodash/get'

const selectGeoState = state => get(state, 'geo')
export const selectGeo = state => selectGeoState(state).data
export const selectGetGeoStatus = state => selectGeoState(state).getGeoStatus
